 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"questionShare": 0
 	};

 	var deferredModules = [];

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}


 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kuaiduizuoye.com/kdactivitymain/";;
 	__webpack_require__.e = (function (webpackRequire) {
 	    var oldWebpackE = webpackRequire.e;
 	    var oldWebpackP = webpackRequire.p;

 	    var newWepackE = function newWepackE(chunkId) {
 	      var _webpackRequire$p$mat, _window$location$href;

 	      var retryTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
 	      var retryId = arguments.length > 2 ? arguments[2] : undefined;

 	      var _originHost = arguments.length > 3 ? arguments[3] : undefined;

 	      var assetsRetry = window.__assets_retry__;
 	      retryId = retryId || assetsRetry.retryIdCreate();
 	      var resolveFn;
 	      var rejectFn;
 	      var defer = new Promise(function (resolve, reject) {
 	        resolveFn = resolve;
 	        rejectFn = reject;
 	      });
 	      var result = oldWebpackE(chunkId);
 	      var domainWithPortRegex = /^(?:https?:\/\/)?([^:/\s]+(:\d+)?)(?:[\/\s:]|$)?/;
 	      var originHost = _originHost || __webpack_require__._originHost || ((_webpackRequire$p$mat = webpackRequire.p.match(domainWithPortRegex)) === null || _webpackRequire$p$mat === void 0 ? void 0 : _webpackRequire$p$mat[1]) || ((_window$location$href = window.location.href.match(domainWithPortRegex)) === null || _window$location$href === void 0 ? void 0 : _window$location$href[1]) || '';
 	      __webpack_require__._originHost = originHost;
 	      var retryConfig = assetsRetry.retryHandle(webpackRequire.p, retryTimes, originHost);
 	      var hasError = false;
 	      result.catch(function (e) {
 	        hasError = true; // 重载失败打点

 	        assetsRetry.reportReload("".concat(webpackRequire.p, "js/").concat(chunkId), 'error', retryTimes, retryId, originHost, 'dynamic'); // 重试次数大于等于3时，url返回undefined,不再重试
 	        // dynamic为true时，不进行动态资源重试

 	        if (retryConfig.url === undefined || assetsRetry.retryConfig.externalTags.dynamic) {
 	          rejectFn(e);
 	          webpackRequire.p = oldWebpackP;
 	          return;
 	        } // 重试打点


 	        webpackRequire.p = retryConfig.url;
 	        assetsRetry.reportReload("".concat(webpackRequire.p, "js/").concat(chunkId), 'retry', retryConfig.retryTimes, retryId, originHost, 'dynamic');
 	        newWepackE(chunkId, retryConfig.retryTimes, retryId, originHost).then(function () {
 	          resolveFn(true);
 	          webpackRequire.p = oldWebpackP;
 	        }, function (e) {
 	          rejectFn(e);
 	          webpackRequire.p = oldWebpackP;
 	        });
 	      }).then(function () {
 	        if (!hasError) {
 	          // 重载成功打点;
 	          if (retryTimes > 0) {
 	            assetsRetry.reportReload("".concat(webpackRequire.p, "js/").concat(chunkId), 'success', retryTimes, retryId, originHost, 'dynamic');
 	          }

 	          resolveFn(true);
 	        }
 	      });
 	      return defer;
 	    };

 	    return newWepackE;
 	  })(__webpack_require__, {"moduleId":"kd-activity","samplingRate":0.01,"debug":true})

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([29,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
